<div class="sync-list-container">
  <nz-table [nzData]="syncData" #syncTableData *ngIf="syncData.length > 0">
    <thead>
      <tr>
        <th>
          {{ 'Integration' | locale  | translate }}
        </th>
        <th>
          {{ 'Channel' | locale  | translate }}
        </th>
        <th>
          {{ 'Synchronizing' | locale  | translate }}
        </th>
        <th>
          {{ 'Processed' | locale  | translate }}
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of syncTableData.data">
        <td>{{ item.integrationId }}</td>
        <td>{{ item.channel.channelDescription }}</td>
        <td>{{ (item.selected ? 'Yes' : 'No') | locale | translate  }}</td>
        <td>{{ (item.processed ? 'Yes' : 'No') | locale | translate  }}</td>
        <td>
          <button
            nz-button
            nzDanger
            *ngIf="item.selected"
            (click)="disableSync(item)"
          >
            {{ 'Disable Sync' | locale  | translate }}
          </button>
          <button nz-button *ngIf="!item.selected" (click)="enableSync(item)">
            {{ 'Enable Sync' | locale  | translate }}
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
  <nz-result
    nzStatus="info"
    [nzTitle]="'This record is not synchronized with any channel' | locale"
    *ngIf="syncData.length === 0"
  >
  </nz-result>
  <button nz-button nzType="primary" (click)="showSyncModal = true">
    {{'Sync' | translate}}
  </button>
</div>

<nz-modal
  [nzVisible]="showSyncModal"
  [nzTitle]="'Choose channels to sync with' | locale  | translate"
  [nzClassName]="'channels-modal'"
  [nzClosable]="false"
>
  <div *nzModalContent>
    <app-product-integrations
      (selectionChanged)="selectedChannelsChanged($event)"
    ></app-product-integrations>
  </div>
  <div *nzModalFooter>
    <button nz-button nzType="primary" (click)="submitChannels()">
      {{'Submit' | translate}}
    </button>
    <button nz-button (click)="cancelSync()">{{'Cancel' | translate}}</button>
  </div>
</nz-modal>
